<template>
	<div class="team-page">
		<header class="page-header">
			<div class="nav-btn" @click="$router.back()">
				<van-icon name="arrow-left" size="20" />
			</div>
			<h1 class="page-title">团队管理</h1>
			<div class="placeholder"></div>
		</header>
		<div class="main-content">
			<section class="user-card">
				<div class="user-profile">
					<div class="user-avatar">
						<div class="avatar-placeholder">{{ getFirstChar(data.name) }}</div>
					</div>
					<div class="user-info">
						<h3 class="name">{{ data.name || '未实名用户' }}</h3>
						<p class="id-number">ID：{{ data.id }}</p>
						
						<div class="superior-info" v-if="data.superior">
							<div class="superior-label">推荐人</div>
							<div class="superior-detail">
								<span class="superior-name">{{ encryptName(data.superior.name || '未实名用户') }}</span>
								<span class="superior-id">{{ encryptPhone(data.superior.phone) }}</span>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="stats-panel">
				<div class="stat-item">
					<div class="stat-value">{{ countTeam }}</div>
					<div class="stat-label">我的团队</div>
				</div>
			</section>
			<div class="level-tabs">
				<div class="tab" :class="active == 1 ? 'active' : ''" @click="change(1)">
					{{ $t('share.level1') }} <span class="tab-badge">{{ countTop1 }}</span>
				</div>
				<div class="tab" :class="active == 2 ? 'active' : ''" @click="change(2)">
					{{ $t('share.level2') }} <span class="tab-badge">{{ countTop2 }}</span>
				</div>
				<div class="tab" :class="active == 3 ? 'active' : ''" @click="change(3)">
					{{ $t('share.level3') }} <span class="tab-badge">{{ countTop3 }}</span>
				</div>
			</div>
			<section class="members-container">
				<div class="members-list" v-if="!listLength">
					<div class="member-item" v-for="i in teamList" :key="i.id || i.phone">
						<div class="member-main">
							<div class="member-avatar">
								<div class="avatar-placeholder">{{ getFirstChar(i.name) }}</div>
							</div>
							<div class="member-details">
								<div class="member-name">{{ encryptName(i.name || '未实名用户') }}</div>
								<div class="member-meta">
									<span class="member-phone">{{ encryptPhone(i.phone) }}</span>
									<span class="join-date">{{ formatDate(i.time) }}</span>
								</div>
							</div>
						</div>
						<!-- <div class="invite-code">展示注册时使用的邀请码</div> -->
					</div>
				</div>
				<div class="empty-state" v-if="listLength">
					<van-empty description="暂无推广用户" />
				</div>
				<!---->
			</section>
		</div>
		<!---->
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue';
	import Vue from 'vue';
	import {
		Empty
	} from 'vant';
	import Clipboard from "v-clipboard";
	Vue.use(Empty).use(Clipboard);
	export default {
		name: "MyTeam",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				countTeam: 0,
				countTop1: 0,
				countTop2: 0,
				countTop3: 0,
				active: 1,
				teamList: [],
				listLength: true,
				qrcode: false,
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/myTeam').then((r) => {
					this.data = r.data;
					this.teamList = r.data.top1;
					if (r.data.top1.length == 0) {
						this.listLength = true;
					} else {
						this.listLength = false;
					}
					this.countTop1 = r.data.top1.length;
					this.countTop2 = r.data.top2.length;
					this.countTop3 = r.data.top3.length;
					this.countTeam = this.countTop1 + this.countTop2 + this.countTop3;
				});
			},
			change(num) {
				this.active = num;
				this.teamList = this.data[("top" + num)];
				if (this.teamList.length == 0) {
					this.listLength = true;
				} else {
					this.listLength = false;
				}
			},
			// 获取用户名的第一个字符，如果没有实名则显示'U'
			getFirstChar(name) {
				if (!name || name === '未实名用户') {
					return 'U';
				}
				return name.charAt(0);
			},
			// 格式化日期，只显示年月日
			formatDate(dateString) {
				if (!dateString) return '';
				// 如果已经是日期格式，直接返回
				if (dateString.includes(' ')) {
					return dateString.split(' ')[0];
				}
				// 如果是时间戳或其他格式，可以在这里添加转换逻辑
				return dateString;
			},
			// 加密姓名：只显示第一个字符，后面用*代替
			encryptName(name) {
				if (!name || name === '未实名用户') {
					return '未实名用户';
				}
				// 如果只有一个字符，直接显示
				if (name.length === 1) {
					return name + '*';
				}
				// 显示第一个字符，后面用*代替
				const firstChar = name.charAt(0);
				return firstChar + '*'.repeat(name.length - 1);
			},
			// 加密手机号：显示前3位和后4位，中间用*代替
			encryptPhone(phone) {
				if (!phone || phone.length < 7) {
					return phone || '';
				}
				// 如果是11位手机号
				if (phone.length === 11) {
					const prefix = phone.substring(0, 3);
					const suffix = phone.substring(7);
					return `${prefix}****${suffix}`;
				}
				// 其他长度的号码，显示前1/3和后1/3
				const showLength = Math.max(2, Math.floor(phone.length / 3));
				const prefix = phone.substring(0, showLength);
				const suffix = phone.substring(phone.length - showLength);
				const hiddenLength = phone.length - 2 * showLength;
				return `${prefix}${'*'.repeat(hiddenLength)}${suffix}`;
			}
		}
	};
</script>

<style lang="less" scoped>
	.team-page {
		min-height: 100vh;
		background-color: #f5f7fa;
		position: relative;
		font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif;
		color: #2c3e50;

		.page-header {
			height: 14.93333vw;
			background-color: #ff8c00;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 4.26667vw;
			position: sticky;
			top: 0;
			z-index: 100;
			box-shadow: 0 .53333vw 2.13333vw rgba(0, 0, 0, .1);

			.nav-btn {
				width: 8.53333vw;
				height: 8.53333vw;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #fff;
			}

			.page-title {
				color: #fff;
				font-size: 4.26667vw;
				font-weight: 500;
				margin: 0;
			}

			.placeholder {
				width: 8.53333vw;
			}
		}

		.main-content {
			padding: 4.26667vw;

			.user-card {
				background: #fff;
				border-radius: 2.13333vw;
				padding: 4.26667vw;
				margin-bottom: 4.26667vw;
				box-shadow: 0 1px .8vw rgba(0, 0, 0, .1);

				.user-profile {
					display: flex;
					align-items: center;

					.user-avatar {
						width: 12.8vw;
						height: 12.8vw;
						border-radius: 50%;
						overflow: hidden;
						margin-right: 3.2vw;

						.avatar-placeholder {
							width: 100%;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
							background-color: #ff8c00;
							color: #fff;
							font-size: 5.33333vw;
							font-weight: 500;
						}
					}

					.user-info {
						flex: 1;

						.name {
							font-size: 4.26667vw;
							font-weight: 500;
							color: #2c3e50;
							margin: 0 0 1.06667vw;
						}

						.id-number {
							font-size: 3.73333vw;
							color: #909399;
							margin: 0 0 2.66667vw;
						}

						/* 上级推荐人信息样式 */
						.superior-info {
							padding-top: 2.66667vw;
							border-top: 1px solid #f0f0f0;
							margin-top: 2.66667vw;

							.superior-label {
								font-size: 3.2vw;
								color: #909399;
								margin-bottom: 1.06667vw;
							}

							.superior-detail {
								display: flex;
								align-items: center;
								justify-content: space-between;
								flex-wrap: wrap;

								.superior-name {
									font-size: 3.73333vw;
									color: #2c3e50;
									font-weight: 500;
									flex: 1;
									margin-right: 2.13333vw;
								}

								.superior-id {
									font-size: 3.46667vw;
									color: #909399;
								}
							}
						}
					}
				}
			}

			.stats-panel {
				background: #fff;
				border-radius: 2.13333vw;
				padding: 4.26667vw;
				margin-bottom: 4.26667vw;
				box-shadow: 0 1px .8vw rgba(0, 0, 0, .1);

				.stat-item {
					text-align: center;

					.stat-value {
						font-size: 7.46667vw;
						font-weight: 600;
						color: #ff8c00;
						line-height: 1.2;
					}

					.stat-label {
						font-size: 3.73333vw;
						color: #5e6d82;
						margin-top: 1.06667vw;
					}
				}
			}

			.level-tabs {
				display: flex;
				background: #fff;
				border-radius: 2.13333vw;
				margin-bottom: 4.26667vw;
				overflow: hidden;
				box-shadow: 0 1px .8vw rgba(0, 0, 0, .1);

				.tab {
					flex: 1;
					text-align: center;
					padding: 3.2vw 0;
					font-size: 3.73333vw;
					color: #5e6d82;
					position: relative;
					transition: all .2s ease;

					&.active {
						color: #ff8c00;
						font-weight: 500;

						&:after {
							content: "";
							position: absolute;
							bottom: 0;
							left: 25%;
							width: 50%;
							height: .53333vw;
							background-color: #ff8c00;
						}
					}

					.tab-badge {
						display: inline-block;
						margin-left: 1.06667vw;
						font-size: 3.2vw;
						color: #ff8c00;
					}
				}
			}

			.members-container {
				background: #fff;
				border-radius: 2.13333vw;
				overflow: hidden;
				box-shadow: 0 1px .8vw rgba(0, 0, 0, .1);

				.empty-state {
					padding: 8.53333vw 0;
					text-align: center;
				}

				.members-list {
					.member-item {
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 3.2vw 4.26667vw;
						border-bottom: 1px solid #e4e7ed;

						&:last-child {
							border-bottom: none;
						}

						.member-main {
							display: flex;
							align-items: center;
							flex: 1;

							.member-avatar {
								width: 10.66667vw;
								height: 10.66667vw;
								border-radius: 50%;
								overflow: hidden;
								margin-right: 3.2vw;

								.avatar-placeholder {
									width: 100%;
									height: 100%;
									display: flex;
									align-items: center;
									justify-content: center;
									background-color: #f0f0f0;
									color: #5e6d82;
									font-size: 4.26667vw;
								}
							}

							.member-details {
								flex: 1;

								.member-name {
									font-size: 4vw;
									font-weight: 500;
									color: #2c3e50;
									margin-bottom: 1.06667vw;
								}

								.member-meta {
									display: flex;
									font-size: 3.46667vw;
									color: #909399;

									.member-phone {
										margin-right: 3.2vw;
									}

									.join-date {
										color: #909399;
									}
								}
							}
						}

						.invite-code {
							font-size: 3.46667vw;
							color: #ff8c00;
							background-color: rgba(255, 140, 0, .08);
							padding: .53333vw 2.13333vw;
							border-radius: 1.06667vw;
						}
					}
				}
			}
		}
	}
</style>